// import { createSelector, createIdSelector } from 'redux-views'

export const getJobs = state => state.firestore.ordered.jobs || []
